import { Component, Host, h, Prop, Element, Build } from '@stencil/core';
@Component({
  tag: 'cms-video',
  styleUrl: 'cms-video.scss',
  shadow: true,
})
export class CmsVideo {
  private videoNode: HTMLVideoElement;

  /**
   * set the static video poster
   */
  @Prop() videoPoster: string;
  /**
   * set the video Source
   */
  @Prop() videoSrc: string;

  @Element() element: HTMLVideoElement;

  componentDidLoad() {
    if (this.videoSrc !== undefined) {
      this.videoNode = this.element.shadowRoot.querySelector('.cms-video');
    }
  }

  private videoHandler() {
    if (this.videoNode !== undefined && this.videoNode.readyState === 0) {
      this.videoNode.load();
      this.videoNode.play();
      this.videoNode.setAttribute('controls', 'true');
      this.videoNode.volume = 0.1;
      const playIconContainer = this.videoNode
        .previousElementSibling as HTMLDivElement;
      playIconContainer.style.display = 'none';
    }
  }

  render() {
    const videoStyles = {
      width: '100%',
      height: 'auto',
      cursor: 'pointer',
    };
    const wrapperStyles = {
      position: 'relative',
      cursor: 'pointer',
      margin: '0 auto',
      maxWidth: '750px',
      maxHeight: '420px',
    };
    return (
      <Host>
        <div style={wrapperStyles}>
          <div
            onClick={() => {
              this.videoHandler();
            }}
            class={'video-play-icon'}
          >
            <cms-icon
              size='xl'
              color-token='--cms-semanticColors-base-medium-iconOnBackground'
              icon='play_withoutBackground'
            ></cms-icon>
          </div>
          <video
            preload='none'
            style={videoStyles}
            onClick={() => {
              this.videoHandler();
            }}
            class={'cms-video'}
            poster={Build.isBrowser ? this.videoPoster : null}
          >
            <source type='video/mp4' src={this.videoSrc} />
          </video>
        </div>
      </Host>
    );
  }
}
